import React from "react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Contact Section */}
      <section
        id="contact"
        className="section"
        style={{ background: "#f56e0b78", padding: "60px 0" }}
      >
        <div className="container">
          <div className="row g-4 align-items-start">
            <div className="col-lg-6" data-aos="fade-right">
              <h2 className="section-title h1 fw-bold mb-3">
                <i className="bi bi-envelope-paper-heart me-2"></i>Let’s build
                something
              </h2>
              <p className="text-dark-50">
                Tell us about your project, timeline, and goals. We’ll reply
                with a plan and quote.
              </p>
              <div className="mt-3 small">
                <div className="mb-1">
                  <i className="bi bi-envelope me-2"></i>
                  <a
                    className="link-warning-active"
                    style={{ color: "#b58900" }}
                    href="mailto:info@mzrsoftware.com"
                  >
                    info@mzrsoftware.com
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <div className="card-soft p-4">
                <div className="row g-3 align-items-center">
                  <div className="col-12">
                    <p className="mb-2">
                      Contact us directly on WhatsApp — no need to fill out a
                      form.
                    </p>
                  </div>
                  <div className="col-12 d-flex gap-2">
                    <a
                      className="btn btn-brand btn-pill"
                      href="https://wa.me/923351206586?text=Hi%20Zeeshan!%20I'm%20interested%20in%20a%20project.%0A%E2%80%A2%20Name:%20%0A%E2%80%A2%20Company:%20%0A%E2%80%A2%20Scope:%20%0A%E2%80%A2%20Timeline:%20%0A%E2%80%A2%20Budget:%20"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="bi bi-whatsapp me-2"></i>Chat on WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-5 text-dark-50 text-center">
        <div className="container small">
          © {currentYear} MZR Software — All rights reserved.
        </div>
      </footer>
    </>
  );
}
